import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import Routes from '../../routes';
import AutoBind from 'react-autobind';

import Modal from '../../util/modal';
import { FormGroup } from '../../util/form-group';

import { Factura_Contado_Individual, Factura_Credito_IndividualSoloUna, Factura_Fiscal_PDF_Listkey, Factura_Fiscal_XML_Listkey, Factura_Credito_IndividualSoloUna_Prueba  } from '../../request/rfc';

export default class Consulta extends Component {

    constructor(props) {
        super(props);
        this.state = {
            baseUrl: document.getElementById('baseUrl').value,
            factura: '',
            folioUID: '',
            modalSucursal: '',
            modalFolio: '',
            showModal: false,
            disabled: false
        };
        AutoBind(this);
    }

    onChange(e) {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    onXML() {
        const { modalSucursal, modalFolio } = this.state;
        Factura_Fiscal_XML_Listkey({ pSucursal: modalSucursal, pFolio: modalFolio })
        .then(({data: Response}) => {
            const { Message, Data } = Response;
            if(Message !== '') {
                 alert(Message);
            } else {
                const pdf = `data:application/octet-stream,${encodeURIComponent(Data.XML_Archivo)}`;
                var element = document.createElement('a');
                element.setAttribute('href', pdf);
                element.setAttribute('download', `${Data.Fiscal_NumeroFactura}.xml`);
                element.style.display = 'none';
                document.body.appendChild(element);
                element.click();
                document.body.removeChild(element);
            }
        })
        .catch((err) =>{ console.log(err); });
    }

    onPDF() {
        const { modalSucursal, modalFolio } = this.state;
        Factura_Fiscal_PDF_Listkey({ pSucursal: modalSucursal, pFolio: modalFolio })
        .then(({data: Response}) => {
            const { Message, Data } = Response;
            if(Message !== '') {
                 alert(Message);
            } else {
                const pdf = `data:application/pdf;base64,${encodeURIComponent(Data.Documento)}`;
                var element = document.createElement('a');
                element.setAttribute('href', pdf);
                element.setAttribute('download', Data.Nombre);
                element.style.display = 'none';
                document.body.appendChild(element);
                element.click();
                document.body.removeChild(element);
            }
        })
        .catch((err) =>{ console.log(err); });


    }

    onCloseModal() {
        this.setState({ showModal: false, disabled: false });
    }

    onSubmit(e) {
        e.preventDefault();
        const { sucursal, caja, factura } = this.state;
        const { tipoFactura } = this.props.match.params;

        if(sucursal === '' || caja === '' || factura === '') {
            alert('Debe ingresar los valores de Sucursal, Caja y Número Factura para poder realizar la consulta.');
            return;
        } else {
            this.setState({ disabled: true });
            const { cliente, correo, usocfdi } = this.props.match.params;
            const params = { pClienteFiscalId: cliente, pCorreo: correo, 
                                pUsoCFDI: usocfdi, pSucursal: sucursal, pCaja: caja, pFactura: factura 
            };

            Factura_Credito_IndividualSoloUna_Prueba(params)
                .then(this.manageResponseConsulta_Prueba)
                .catch((err) => { console.log(err); this.setState({ disabled: true }); });

            //if(tipoFactura == '0') {
                Factura_Contado_Individual(params)
                .then(this.manageResponseConsulta)
                .catch((err) => { console.log(err); this.setState({ disabled: false }); });
            //} else {
            //    Factura_Credito_IndividualSoloUna(params)
            //    .then(this.manageResponseConsulta)
            //    .catch((err) => { console.log(err); this.setState({ disabled: false }); });
            //}

        }

        this.setState({ disabled: false });

    }

    manageResponseConsulta({ data: Response }) {
        const { Message, Data }  = Response;
        if(Message !== '') {
            alert(Message);
            this.setState({ disabled: false });
        } else {
            alert('Se generó correctamente la factura.');
            this.setState({ showModal: true, serie: Data.Serie, modalFolio: Data.NumeroFactura, 
                            folioUID: Data.UUID, modalSucursal: Data.Suc_Id 
            });
        }
    }

    manageResponseConsulta_Prueba({ data: Response }) {
        const { Message, Data } = Response;
        if (Message !== '') {
            this.setState({
                disabled: true
            });
        } else {
            this.setState({
                disabled: true
            });
        }
    }
    render() {
        
        const { baseUrl, sucursal, caja, factura, showModal, modalSucursal, modalFolio, disabled } = this.state;
        const linkStyle = { 'pointerEvents': disabled ? 'none' : 'auto' };
        const cssClassSpin = disabled ? 'fas fa-spinner fa-spin' : 'fas fa-search';
        
        return (
            <Fragment>
                <div className="row" id="consulta">
                    <div className="col-md-12">
                        <div className="row">
                            <div className="col-md-12">
                                <Link to={`${baseUrl}${Routes.Home}`} className="btn btn-custom-theme float-right" style={linkStyle}>
                                    <i className="fas fa-angle-double-left"></i>
                                </Link>
                            </div>
                        </div>
                        <div className="row">
                            <form className="col-md-12" onSubmit={this.onSubmit}>
                                <div className="row">
                                    <FormGroup col="col-md-4"
                                        className="form-control"
                                                    type="text" 
                                                    name="sucursal" 
                                                    label="Sucursal" 
                                                    value={sucursal} 
                                                    readOnly={disabled}
                                                    onChange={this.onChange} />
                                    
                                    <FormGroup col="col-md-4" 
                                        className="form-control"
                                                    type="text" 
                                                    name="caja" 
                                                    label="Caja" 
                                                    value={caja} 
                                                    readOnly={disabled}
                                                    onChange={this.onChange} />
                                    
                                    <FormGroup col="col-md-4" 
                                        className="form-control"
                                                    type="text" 
                                                    name="factura" 
                                                    label="Ticket" 
                                                    value={factura} 
                                                    readOnly={disabled}
                                                    onChange={this.onChange} />
                                    
                                </div>
                                <div className="row">
                                    <div className="form-group col-md-12">
                                        <button type="submit" className="btn btn-custom-theme margin-top-30 ml-sm-3 float-right" disabled={disabled} >
                                            <i className={cssClassSpin}></i>
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <Modal show={showModal} 
                         serie={modalSucursal}
                         folio={modalFolio}
                         onXML={this.onXML}
                         onPDF={this.onPDF}
                         onCloseModal={this.onCloseModal}
                />
            </Fragment>
        )
    }

};


// WEBPACK FOOTER //
// ./Public/src/js/component/ticket/index.jsx